import React from 'react';
import { deckPages } from '../../data/deck';
interface SectionProps {
  id: string;
  children: React.ReactNode;
}

/** One full-height page in the scrolling presentation, with a quiet running header. */
export function Section({
  id,
  children
}: SectionProps) {
  const index = deckPages.findIndex(page => page.id === id);
  const page = deckPages[index];
  return <section id={id} aria-label={page?.label} className="relative flex min-h-screen w-full flex-col border-t border-[var(--fg)]/[0.08] bg-[var(--surface)] px-8 py-6 lg:px-14" data-id="element-274" data-mp="3lbchmku00ki0">
      <header className="flex items-center justify-between gap-4" data-id="element-275" data-mp="hunaoxqi78rt">
        <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/40" data-id="element-276" data-mp="33daazl5ixnc">
          {String(index + 1).padStart(2, '0')} · {page?.label}
        </span>
        <span className="hidden text-[10px] font-semibold uppercase tracking-[0.24em] text-[var(--fg)]/30 sm:inline" data-id="element-277" data-mp="vrivtok14qo8">
          REKOVELLE × Snakker · From attention to action
        </span>
      </header>
      <div className="flex flex-1 items-center py-12 lg:py-10" data-id="element-278" data-mp="2i6m4a93akzdt">
        <div className="mx-auto w-full max-w-[1360px]" data-id="element-279" data-mp="2d6zr1zngrj50">{children}</div>
      </div>
    </section>;
}